import { useInstance, remove } from 'intact-vue-next';
import { position } from '../position';
import { SHOW } from './constants';
export function usePosition(elementRef) {
  var instance = useInstance();
  instance.on(SHOW, center);
  instance.on('afterClose', onAfterLeave);
  instance.watch('container', function () {
    if (!instance.get('value')) return;
    center();
  }, {
    presented: true,
    inited: true
  });
  function center() {
    position(elementRef.value, {
      // ensure title visible always
      using: function using(feedback, position) {
        var height = feedback.element.height;
        var scrollTop = window.pageYOffset;
        var outerHeight = window.document.documentElement.clientHeight;
        if (height > outerHeight) {
          position.top = scrollTop;
        }
      },
      // let dialog padding top half of padding bottom
      my: 'center center+16%',
      at: 'center center-16%'
    });
  }
  function onAfterLeave() {
    var element = elementRef.value;
    if (element) {
      // in `destroy` mode, the elementRef.value doesn't exist
      var style = element.style;
      style.left = style.top = '';
    }
    if (!instance.useAsComponent) {
      remove(instance.$vNode, document.body, false);
    }
  }
}